module.exports = __webpack_public_path__ + "media/honey-icons/icon-security-privacy-0d65141a.svg";